<script>
export default {
  name: 'App',
  mounted () {
    this.$store.dispatch('user/get').catch(() => {
      // not authorized
    });
  }
};
</script>
